// extracted by mini-css-extract-plugin
export default {"toggle_container":"toggle_toggle_container__P+Ex1","toggle":"toggle_toggle__gmPNi"};